import React from 'react';
import './ImageCardSection.css';
import sportsImage from '../Images/sports.jpg';
import concertImage from '../Images/concert.jpg';
import comedyImage from '../Images/comedy.jpg';
import broadwayImage from '../Images/broadway.jpg';
import festivalImage from '../Images/festival.jpg';
import symphonyImage from '../Images/symphony.jpg';

const ImageCardSection = ({ onSignupClick }) => {
  const images = [
    { src: sportsImage, alt: 'Sports' },
    { src: concertImage, alt: 'Concerts' },
    { src: comedyImage, alt: 'Comedy' },
    { src: broadwayImage, alt: 'Broadway' },
    { src: festivalImage, alt: 'Festivals' },
    { src: symphonyImage, alt: 'Symphony' },
  ];

  return (
    <section className="image-card-section">
      <div className="image-card-container">
        {images.map((image, index) => (
          <div key={index} className="image-card">
            <div className="image-overlay"></div>
            <p className="image-card-label">{image.alt}</p>
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>
      <div className="text-container">
        <div className="text-content">
          <h2>Don't miss out on events happening in your area</h2>
          <p>Sign up and stay connected for added events and new features.</p>
          {/* <button className="sign-up-button" type="button" onClick={onSignupClick}>
            Sign Up
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default ImageCardSection;
